// Model that checks to see if a user's password matches their Garmin guid
// Returns a token upon success
// Endpoint documentation: https://servicestest.garmin.com/accountProcessServices/swagger-ui.html#!/account-management-controller/checkPasswordForTokenUsingPOST
import axios from 'axios';

export default class CheckPasswordWithToken {
    constructor(args) {
        this.url = `/it-proxy/accountProcessServices/customerAccounts/${args.garminGuid}/checkPasswordForToken`; // Owned by IT not DI
        this.httpCall = axios.create({
            baseURL: '/modern', // Override of the globally set baseURL for axios
            headers: { 'Content-Type': 'text/plain' } // The endpoint requires the password be sent as plain text and not in a JSON format
        });
    }

    verify(password, successHandler, passwordEntryFail, passwordConfirmFail, passwordConfirmNetworkFail) {
        if (
            typeof successHandler !== 'function' ||
            typeof passwordEntryFail !== 'function' ||
            typeof passwordConfirmFail !== 'function' ||
            typeof passwordConfirmNetworkFail !== 'function'
        ) {
            throw 'Success and fail handlers are required, hmm kay?';
        }

        if (password.length <= 0) {
            passwordEntryFail();
            return;
        }

        this.httpCall
            .post(this.url, password)
            .then((response) => {
                // The password max length is from the password max length in the SSO create new account widget
                // response.data is either the password challenge token sent from IT when the password the user gave matches the password in the DB or false if it doesn't match
                if (password.length <= 50 && response.data) {
                    successHandler(response.data);
                } else {
                    passwordConfirmFail();
                }
            })
            .catch((err) => {
                passwordConfirmNetworkFail();
            });
    }
}
